import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { OptionKey } from '@common-fe/common-fe';

import { api } from '@/api';
import { Roles } from '@/common/constants';
import { Pagination } from '@/common/types';
import { API_URL } from '@/dtos';
import { useHasAccess } from '@/modules/core/hooks';

import { ITaxForm, ITaxFormType } from '../TaxForms.types';

interface Params {
  years?: OptionKey[];
  page: number;
  perPage: number;
  sortBy?: OptionKey;
  enabled?: boolean;
}
interface Response {
  id: number;
  name: string;
  type: ITaxFormType;
}
export const TAX_FORMS_LIST_KEY = 'TAX_FORMS_LIST_KEY';
const SORT_KEY = 'created_at';
const useTaxFormsListQuery = (params: Params) => {
  const isLimitedAccess = useHasAccess([
    {
      role: Roles.employeeLimitedAccess,
    },
  ]);
  const { data, isLoading, isSuccess } = useQuery(
    [
      TAX_FORMS_LIST_KEY,
      params.page,
      params.perPage,
      params.sortBy,
      isLimitedAccess,
      ...(params?.years ? params?.years || [] : []),
    ],
    () =>
      // TODO: the type is missing
      api.get<Pagination<Response>>(API_URL.V2_TAX_FORMS, {
        params: {
          sort: params.sortBy ? `${SORT_KEY},${params.sortBy}` : undefined,
          tax_years: params?.years?.length ? params?.years?.join(',') : undefined,
          page: params.page,
          size: params.perPage,
        },
      }),
    {
      enabled: !isLimitedAccess,
    }
  );
  const formattedData = useMemo<ITaxForm[]>(() => {
    const list = data?.data?.content || [];

    return list.map((item) => ({
      id: `${item.id}`,
      name: item.name,
      type: item.type,
    }));
  }, [data?.data]);

  const is1099Exists = useMemo(() => {
    const list = data?.data?.content || [];
    return list.some((item) => item.type === ITaxFormType.TaxForm1099);
  }, [data?.data]);
  const is5498Exists = useMemo(() => {
    const list = data?.data?.content || [];
    return list.some((item) => item.type === ITaxFormType.TaxForm5498);
  }, [data?.data]);
  return {
    total: data?.data?.totalElements || 0,
    formattedData,
    isLoading,
    isSuccess,
    is1099Exists,
    is5498Exists,
  };
};

export default useTaxFormsListQuery;
